module.exports = __webpack_public_path__ + "img/de.599e2907.svg";